import type { DefaultMantineColor } from "@mantine/core"
import { hash32 } from "./hash32"

export const colors: DefaultMantineColor[] = [
  "dark",
  "gray",
  "red",
  "pink",
  "grape",
  "violet",
  "indigo",
  "blue",
  "cyan",
  "green",
  "lime",
  "yellow",
  "orange",
  "teal",
]

export function stringToColor(str: string, seed?: number) {
  const hash = hash32(str, seed)
  const r = (hash & 0xff0000) >> 16
  const g = (hash & 0x00ff00) >> 8
  const b = hash & 0x0000ff
  return `rgb(${r}, ${g}, ${b})`
}

export function valueToColor(value: number, max: number, min: number = 0) {
  const r = Math.floor((max - value) * (213 / (max - min)))
  const g = 213 - r
  return `rgb(${r}, ${g}, 42)`
}
